import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type FinanceProductTabsClasses = 'tabs' | 'item' | 'selectedItem' | 'indicator' | 'tabLabel';

const FinanceProductTabsStyles = makeStyles<ISpcTheme, FinanceProductTabsClasses>(
  theme => ({
    tabs: {
      minHeight: 30,
      marginRight: 20,
      [theme.breakpoints.down('xs')]: {
        paddingBottom: 15,
        margin: 0,
      },
    },
    item: {
      cursor: 'pointer',
      textTransform: 'uppercase',
      color: theme.palette.grey[700],
      minWidth: 80,
      minHeight: 30,
    },
    selectedItem: {
      pointerEvents: 'none',
      color: theme.palette.grey[800],

      '& span': {
        fontWeight: 'bolder',
      },
    },
    indicator: {
      height: 3,
    },
    tabLabel: {},
  }),
  { name: 'Customise_FinanceProductTabs' },
);

export default FinanceProductTabsStyles;
